module.exports = __webpack_public_path__ + "static/media/3.Mist Blower.cbcd9253.jpg";